import { ExportDefaultType } from '../types';
import ChannelSelect from './ChannelSelect';
import DateSelect from './DateSelect';
import VersionTimeSelect from './VersionTimeSelect';
import HeroSelect from './HeroSelect';
import HashtagSelect from './HashtagSelect';
import FollowerRange from './FollowerRange';
import InvalidSelect from './InvalidSelect';
import LanguageSelect from './LanguageSelect';
import MonitorSelect from './MonitorSelect';
import PlatformSelect from './PlatformSelect';
import RatingSelect from './RatingSelect';
import RegionAndLanguageSelect from './RegionAndLanguageSelect';
import RegionSelect from './RegionSelect';
import SentimentSelect from './SentimentSelect';
import TopicSelect from './TopicSelect';
import VersionSelect from './VersionSelect';
import MonitorSourceSelect from './MonitorSourceSelect';
import PlatformGameList from './PlatformGameList';
import GPTSelect from './GPTSelect';
import GameTypeSelect from './GameTypeSelect';
import ChannelTypeSelect from './ChannelTypeSelect';
import DataSourceSelect from './DataSource';
import KeyWordsSelect from './KeyWordsSelect';
import VideoTagSelect from './VideoTagSelect';
import ReviewersSelect from './ReviewersSelect';
import ChannelTypeSingleSelect from './ChannelTypeSingleSelect';
import PerspectiveSelect from './PerspectiveSelect';
import EngagementPerformanceSelect from './EngagementPerformanceSelect';
import EngagementsRange from './EngagementsRange';
import CommentsRange from './CommentsRange';
import LikesRange from './LikesRange';
import SharesRange from './SharesRange';
import ReviewsTypeSelect from './ReviewsTypeSelect';
import MatchedTypeSelect from './MatchedTypeSelect';
import SentimentClauseSelect from './SentimentClauseSelect';
import KeywordFilterTypeSelect from './KeywordFilterTypeSelect';
import RefundedSelect from './RefundedSelect';
import LiveVenuesSelect from './LiveVenuesSelect';
import InfluencersTypeSelect from './InfluencersTypeSelect';
import StarredTagSelect from './StarredTagSelect';
import FreePlayedSelect from './FreePlayedSelect';
import SteamPurchaseSelect from './SteamPurchasesSelect';
import RecordTimesSelect from './RecordTimesSelect';
import ReviewTimesSelect from './ReviewTimesSelect';
import SteamIdSelect from './SteamIdSelect';
import EarlyAccessSelect from './EarlyAccessSelect';
import HelpfulSelect from './HelpfulSelect';
import FunnysSelect from './FunnysSelect';
import SteamRatingSelect from './SteamRatingSelect';
import AvgEngagementRateSelect from './AvgEngagementRateSelect';
import GameAffinitySelect from './GameAffinitySelect';
import TotalPublicationSelect from './TotalPublicationSelect';
import AvgViewsSelect from './AvgViewsSelect';
import BrandRelatedPublicationsSelect from './BrandRelatedPublicationsSelect';
import BrandRelatedAvgViewsSelect from './BrandRelatedAvgViewsSelect';
import GenreGameListSelect from './GenreGameListSelect';
import GenreGameAndAffinitySelect from './GameCoveredAndAffinitySelect';
import BrandAffinitySelect from './BrandAffinitySelect';
import GenreSelect from './GenreSelect';
import GameListSelect from './GameListSelect';
import NewsDataSourceSelect from './NewsDataSourceSelect';
import NewsUVPMSelect from './NewsUVPMSelect';
import NewsCoverageTypeSelect from './NewsCoverageTypeSelect';
import NewsBateSelect from './NewsBateSelect';
import CompetitorGameListSelect from './CompetitorGameListSelect';
import VideoTypeSelect from './VideoTypeSelect';
import KolTagsSelect from './KolTagsSelect';
import ViewsSelect from './ViewsSelect';
import {
  getCompetitorTableHeader,
  getFilterSettingListByGame,
  getVoiceLanguageFilter,
} from '@op/services';
import GameSelectionSelect from './GameSelectionSelect';
import MetricsSelect from './MetricsSelect';
import CompareDateSelect from './CompareDateSelect';
import ManyCompareGameSelect from './ManyCompareGameSelect';
import NIKKESelect from './NIKKESelect';
import KeywordPreview from './KeywordPreview';
import GPTPreview from './GPTPreview';
import UrlAnalysisSelect from './UrlAnalysisSelect';
import URLPreview from './URLPreview';
import IntentSelect from './IntentSelect';
import SentimentEditStatusSelect from './SentimentEditStatusSelect';
import VoiceLanguageSelect from './VoiceLanguageSelect';
import SubTopicSentimentSelect from './SubTopicSentimentSelect';
import LevelUpGameSelectionSelect from './LevelUpGameSelectionSelect';
import GPTAgent from './GPTAgent';
import GPTType from './GPTType';
import GPTAnalysisTarget from './GPTAnalysisTarget';
import KeyKOLSelect from './KeyKOLSelect';
import ProductSelect from './ProductSelect';
import PostStreamRange from './PostStreamRange';
import PostAuthorTypeSelect from './PostAuthorTypeSelect';
import XboxEditionSelect from './XboxEditionSelect';
import CommentsUnderThePostContainingKeywordsIncludedSelect from './CommentsUnderThePostContainingKeywordsIncludedSelect';
import KolRegionSelect from './KolRegionSelect';
import VideoAITagSelect from './VideoAITagSelect';
import KeywordTopicInputPreview from './KeywordTopicPreview';
import KeywordInputPreview from './KeywordInputPreview';
import ZoneGameSelect from './ZoneGameSelect';
import GPTTriggerAgent from './GPTTriggerAgent';
import BlackGrayAuthorSelect from './BlackGrayAuthorSelect';
import AigcSelect from './AigcSelect';

/**
 * TODO
 * 这三个key比较复杂，看看有没有优化点，是否可以将requestKey和componentPropsKey合并
 * requestKey: cond接口请求的参数
 * interfaceKey：接口返回数据的key
 * componentPropsKey：组件内部参数的key值
 *                    主要是给多数据源的组件参数处理成指定key值，
 *                    如果单数据源，直接使用filterConfig的key作为子组件参数
 * resultKey: 提交返回接口使用的key
 */
const ExportDefaultValue: ExportDefaultType = {
  channel: {
    component: ChannelSelect,
    requestKey: 'channel',
  },
  date: {
    component: DateSelect,
    requestKey: ['all_of_time_start_time'],
    interfaceKey: ['all_of_time_start_time', 'game_steam_date_type'], // 这个key没有请求作用，但是作为传入组件的参数
  },
  versionTime: VersionTimeSelect,
  invalid: InvalidSelect,
  refunded: RefundedSelect,
  steamPurchase: SteamPurchaseSelect,
  starredTag: StarredTagSelect,
  freePlayed: FreePlayedSelect,
  recordTimes: RecordTimesSelect,
  reviewTimes: ReviewTimesSelect,
  monitor: {
    component: MonitorSelect,
    requestKey: [
      'monitor_by_account_category',
      'monitor_by_keyword',
      'keyword_mutual_account_config',
    ],
  },
  language: {
    component: LanguageSelect,
    requestKey: 'region_language',
  },
  gptSelect: {
    component: GPTSelect,
    requestKey: 'report_gpt_config',
  },
  region: {
    component: RegionSelect,
    requestKey: 'region_country',
  },
  rating: RatingSelect,
  steamRating: SteamRatingSelect,
  regionAndLanguage: {
    component: RegionAndLanguageSelect,
    requestKey: ['region_language', 'region_country'],
  },
  genreGameAndAffinity: GenreGameAndAffinitySelect,
  sentiment: SentimentSelect,
  sentimentClause: SentimentClauseSelect,
  topic: {
    component: TopicSelect,
    requestKey: ['topic', 'key_topic'],
    interfaceKey: ['topic_trans', 'key_topic'],
  },
  hero: {
    component: HeroSelect,
    requestKey: 'hok_hero',
    interfaceKey: 'hok_hero',
  },
  hashtag: {
    component: HashtagSelect,
    requestKey: 'real_hashtag',
    interfaceKey: 'real_hashtag',
  },
  version: {
    component: VersionSelect,
    requestKey: 'version',
  },
  platform: {
    component: PlatformSelect,
    requestKey: 'platform',
  },
  videoTag: {
    component: VideoTagSelect,
    requestKey: 'video_label',
  },
  reviewers: ReviewersSelect,
  keyWords: KeyWordsSelect,
  monitorSource: MonitorSourceSelect,
  reviewType: ReviewsTypeSelect,
  platformGame: PlatformGameList,
  followerRange: FollowerRange,
  gameType: GameTypeSelect,
  channelType: ChannelTypeSelect,
  dataSource: DataSourceSelect,
  channelTypeSingle: ChannelTypeSingleSelect,
  perspective: PerspectiveSelect,
  engagementPerformance: EngagementPerformanceSelect,
  engagementsRange: EngagementsRange,
  commentsRange: CommentsRange,
  likesRange: LikesRange,
  sharesRange: SharesRange,
  matchedType: MatchedTypeSelect,
  keywordFilterType: KeywordFilterTypeSelect,
  liveVenues: LiveVenuesSelect,
  influencersType: InfluencersTypeSelect,
  steamIds: SteamIdSelect,
  earlyAccess: EarlyAccessSelect,
  funnys: FunnysSelect,
  helpfuls: HelpfulSelect,
  avgEngagementRate: AvgEngagementRateSelect,
  gameAffinitys: GameAffinitySelect,
  totalPublications: TotalPublicationSelect,
  avgViews: AvgViewsSelect,
  views: ViewsSelect,
  brandRelatedPublications: BrandRelatedPublicationsSelect,
  brandRelatedAvgViews: BrandRelatedAvgViewsSelect,
  genreGameList: GenreGameListSelect,
  brandAffinitys: BrandAffinitySelect,
  genre: GenreSelect,
  game: GameListSelect,
  newsBate: {
    component: NewsBateSelect,
    requestKey: 'news_beat',
  },
  newsCoverageType: {
    component: NewsCoverageTypeSelect,
    requestKey: 'news_coverage_type',
  },
  newsUVPM: NewsUVPMSelect,
  newsDataSource: {
    component: NewsDataSourceSelect,
    requestKey: 'news_data_source',
  },
  competitorGames: {
    component: CompetitorGameListSelect,
    requestFunc: params => {
      return getCompetitorTableHeader({
        ...params,
        exclude_stats_data: true,
      }).then((data: any) => {
        const { competitors } = data || {};
        const competitorList = competitors?.infos || [];
        return {
          competitor_games: competitorList,
        };
      });
    },
    needCache: false,
    condCacheKey: 'competitor_games',
  },
  kolTags: KolTagsSelect,
  videoType: VideoTypeSelect,
  compareGamesSelection: {
    component: GameSelectionSelect,
    requestFunc: params => {
      return getCompetitorTableHeader({
        ...params,
        exclude_stats_data: true,
      }).then((data: any) => {
        return { ori_competitor_games: data };
      });
    },
    needCache: false,
    condCacheKey: 'ori_competitor_games',
  },
  metrics: {
    component: MetricsSelect,
    requestFunc: params => {
      return getFilterSettingListByGame({
        uid: params.edition_unified_id,
        uid_type: params.id_type,
        top_n: 1,
        business_type: 2,
      })
        .then((data: any) => {
          const filter = data?.[0] || {};
          let filterValue: any = {};
          try {
            filterValue = JSON.parse(filter.filter_info);
          } catch (error) {
            filterValue = {};
          }

          // 自定义指标放在这里
          return filterValue;
        })
        .catch(() => {
          return {};
        });
    },
    needCache: false,
    condCacheKey: 'metrics',
    interfaceKey: ['metrics', 'metricsValue'],
  },
  compareDate: CompareDateSelect,
  manyCompareGame: {
    component: ManyCompareGameSelect,
    requestFunc: params => {
      return getCompetitorTableHeader({
        ...params,
        exclude_stats_data: true,
      }).then((data: any) => {
        return { ori_competitor_games: data };
      });
    },
    needCache: false,
    condCacheKey: 'ori_competitor_games',
    interfaceKey: ['compare_games', 'ori_competitor_games'],
  },
  NIKKE: {
    component: NIKKESelect,
    requestKey: 'hok_hero',
    interfaceKey: 'hok_hero',
  },
  keywordPreview: KeywordPreview,
  keywrodInputPreview: KeywordInputPreview,
  topicInputPreview: KeywordTopicInputPreview,
  gptPreview: GPTPreview,
  urlAnalysis: UrlAnalysisSelect,
  urlPreview: URLPreview,
  intent: {
    component: IntentSelect,
    requestKey: 'vrta_intent',
  },
  sentimentEditStatus: SentimentEditStatusSelect,
  voiceLanguage: {
    component: VoiceLanguageSelect,
    requestFunc: params =>
      getVoiceLanguageFilter({
        ...params,
      }).then((data: any) => ({
        voice_language: data,
      })),
    needCache: true,
    condCacheKey: 'voice_language',
  },
  subTopicSentiment: SubTopicSentimentSelect,
  levelUpGame: LevelUpGameSelectionSelect,
  gptAgent: GPTAgent,
  gptAnalysisTarget: GPTAnalysisTarget, 
  gptType: GPTType,
  gptTriggerAgent: GPTTriggerAgent,
  keyKol: {
    component: KeyKOLSelect,
    requestKey: 'front_web_config',
    params: { sub_request_type: ['kol_accounts'] },
  },
  product: {
    component: ProductSelect,
    requestKey: 'steam_game_product_ids',
  },
  postStream: PostStreamRange,
  postAuthorType: PostAuthorTypeSelect,
  xboxEdition: {
    component: XboxEditionSelect,
    requestKey: 'xbox_game_package_ids',
  },
  commentsUnderThePostContainingKeywordsIncluded: {
    component: CommentsUnderThePostContainingKeywordsIncludedSelect,
  },
  kolRegion: {
    component: KolRegionSelect,
    requestKey: 'region_country',
  },
  videoAITag: {
    component: VideoAITagSelect,
    requestKey: 'video_tags',
  },
  zoneGames: {
    component: ZoneGameSelect,
    requestKey: 'zone_games',
  },
  blackGrayAuthor: BlackGrayAuthorSelect,
  aigc: AigcSelect,
};

export default ExportDefaultValue;
